import { Modal } from 'components/core-ui/Modal'
import { Table } from 'components/core-ui/Table'
import { LocationsModalProps, LocationTableItem } from 'components/waste-management/interfaces'
import { useMemo, useState } from 'react'
import { getColumns } from './helpers'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { useNotification } from 'hooks'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'

const LocationsModal = (props: LocationsModalProps) => {
  const { isModalOpen, closeModal, companyId } = props

  const [tableItems, setTableItems] = useState<LocationTableItem[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const { showNotification } = useNotification()

  const columns = useMemo(() => getColumns(), [])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: `/waste-management-system/company/${companyId}/locations`,
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor pentru locatiile asociate unei companii colectoare. ${formatErrorMessage(
          error
        )}`,
        type: 'error'
      })
    }
  }

  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal} modalTitle="Locatii" modalWidth="80%">
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
      />
    </Modal>
  )
}

export default LocationsModal
